import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useSearchParams } from 'react-router-dom';
import { PRESENTATION_TABS_INDEX, setCurrentTab } from '../../../redux/slices/presentationsSliceBO';

const PESTANA_POR_NOMBRE: Record<string, PRESENTATION_TABS_INDEX> = {
    rgrl: PRESENTATION_TABS_INDEX.RGRL,
    rar: PRESENTATION_TABS_INDEX.RAR,
    svcc: PRESENTATION_TABS_INDEX.SVCC
};

/**
 * `?tab=svcc` (o `rar`, `rgrl`) abre esa pestaña de Presentaciones de
 * backoffice. Es como llegan los avisos —campanita y "Ver más" del mail—, que
 * antes caían en la pestaña que hubiera quedado guardada (RGRL por defecto).
 * El parámetro se saca de la URL después de aplicarlo, para que cambiar de
 * pestaña a mano no vuelva a pisarlo.
 */
const usePestanaDesdeUrl = () => {
    const dispatch = useDispatch();
    const [searchParams, setSearchParams] = useSearchParams();
    const pestana = searchParams.get('tab');

    useEffect(() => {
        if (!pestana) return;
        const indice = PESTANA_POR_NOMBRE[pestana.toLowerCase()];
        if (indice !== undefined) dispatch(setCurrentTab(indice));
        const sinPestana = new URLSearchParams(searchParams);
        sinPestana.delete('tab');
        setSearchParams(sinPestana, { replace: true });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [pestana]);
};

export default usePestanaDesdeUrl;
